import { render, staticRenderFns } from "./ModalProjectAdd.vue?vue&type=template&id=206f3bae&lang=pug"
import script from "./ModalProjectAdd.vue?vue&type=script&lang=js"
export * from "./ModalProjectAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports